<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-row>
      <v-col>
        <p class="text-xl font-medium">Tổng quan</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="3" sm="3" align="center">
        <v-card class="px-7 py-6 mr-9 mb-5" height="120" width="230" color="#FBB040">
          <p class="text-white text-lg text-medium mb-0">Sửa chữa</p>
          <p class="text-4xl font-bold text-white mb-0">{{ totalElevator }}</p>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3" sm="3" align="center">
        <v-card class="px-7 py-6 mr-9 mb-5" height="120" width="230" color="#FBB040">
          <p class="text-white text-lg text-medium mb-0">Bảo hành</p>
          <p class="text-4xl font-bold text-white mb-0">{{ totalDevice }}</p>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import { Container } from "vue-dndrop";
import { EMPTY } from "~/utils/constants";

export default {
  name: "Home",
  components: {
    Container,
  },
  data() {
    return {
      role: "admin",
      listStatistics: [
        { name: "Mạch", count: 45 },
        { name: "Khách hàng", count: 45 },
        { name: "Thang máy", count: 45 },
        { name: "Thông báo", count: 230 },
        { name: "Tài khoản", count: 45 },
      ],
      headers: [{ text: "Vị thuốc", value: "id", sortable: false }],
      options: { page: 1, itemsPerPage: 5 },
      list: [],
      searchString: EMPTY,
      sortingList: [],
      modelSort: null,
      totalItems: 1,
      isLoading: false,
      totalDevice: 0,
      totalElevator: 0,
      totalUser: 0,
      totalNotification: 0,
    };
  },
  methods: {
    async getStatisticInfomation() {
      this.isLoading = true;
      try {
        const data = await this.$services.commonService.getStatisticInfomation();
        this.totalDevice = data?.totalDevice;
        this.totalUser = data?.totalUser;
        this.totalElevator = data?.totalElevator;
        this.totalNotification = data?.totalNotification;
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
  },
  async created() {
    await this.getStatisticInfomation();
  },
};
</script>
